var App = App || {};

App.SiteModals = (function ($) {
    "use strict";

    var $slider,
        activeSlider = false;


    ////////////////////////////////////////////////////////////////////////////
    // MODAL TRIGGERS
    ////////////////////////////////////////////////////////////////////////////
    function ModalsTriggers() {
        $("a").on("click", function (e) {
            // trigger Site Tour Modal
            if ($(this).attr("href") === "#ModalSiteTour") {
                $("#ModalSiteTour").modal("show");
            }
        });
    }


    ////////////////////////////////////////////////////////////////////////////
    // SITE TOUR MODAL
    ////////////////////////////////////////////////////////////////////////////
    function ModalSiteTour() {

        var $tour = $("#ModalSiteTour"),
            tourId = $tour.data('tourid');

        if ($tour && !tourDismissed(tourId)) {
            $tour.modal("show");

            $tour.find("button[data-dismiss='modal']").on("click", function (e) {
                e.preventDefault();
                dismissTour($tour, tourId);
            });
        }

        $("#ModalSiteTour").find("button[data-scroll='modal']").on("click", function () {
            $("#ModalSiteTour").animate({
                scrollTop: $($("#ModalSiteTour").find(".site-tour-item")[0]).offset().top - 450
            }, 400);
        });


        function dismissTour($tour, tourId) {
            App.Cookies.setItem("TourDismissedAmeris", "true", Infinity, "/");
        }

        function tourDismissed(tourId) {
            return (App.Cookies.getItem("TourDismissedAmeris") === "true") ? true : false;
        }
    }

    ////////////////////////////////////////////////////////////////////////////
    // SITE TOUR CAROUSEL SUPPORT
    ////////////////////////////////////////////////////////////////////////////
    function ModalSiteTourSlides() {
 
        $slider = $("#ModalSiteTour").find(".modal-body-carousel-items")

        if (window.innerWidth >= 991 && !activeSlider) {
            window.setTimeout(function () { initSlideShow() },2000);
            
        }

        $(window).on("resize", function () {
            // if we re now less than 991, AND we are currently unslicked, THEN we need to rebuild the slider.
            if (window.innerWidth >= 991 && !activeSlider) {
                initSlideShow();
            }
        });


        function initSlideShow() {
            activeSlider = true;

            if ($(window).width() >= 991) {
                $(".site-tour-intro .layout").css("height", 600 + "px");
                $(".site-tour-item .layout").css("height", 600 + "px");
            }


            $slider.slick({
                dots: false,
                arrows: true,
                appendArrows: $(".modal-body-carousel-controls"),
                prevArrow: '<button type="button" class="slick-prev" tabindex="0"><span class="sr-only">Previous</span></button>',
                nextArrow: '<button type="button" class="slick-next" tabindex="0"><span class="sr-only">Next</span></button>',
                autoplay: false,
                fade: true,
                adaptiveHeight: false,
                infinite: false,
                slidesToShow: 1,
                currentSlide: 0,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    },
                ]
            });

            $slider.on("destroy", function () {
                activeSlider = false;
            });


            window.setTimeout(function () {
                console.log();
                $(".modal-close button").focus();
                $("#ModalSiteTour .modal-body-carousel-items").slick("slickGoTo", 0, true);
            }, 1000);

            $slider.on("afterChange", function (event, slick, currentSlide, nextSlide) {
                ModalSiteTourCarousel(slick.$slides.length, currentSlide);

                if (currentSlide !== 0) {
                    $(".modal-body-carousel-controls").css("display", "block");
                }
                else {
                    $(".modal-body-carousel-controls").css("display", "none");
                }
            });

            $("#ModalSiteTour").find("button[data-reset='carousel']").on("click", function () {
                $("#ModalSiteTour .modal-body-carousel-items").slick("slickGoTo", 0, false);
            });

            $("#ModalSiteTour").find(".start-tour").on("click", function () {
                $("#ModalSiteTour .modal-body-carousel-items").slick("slickGoTo", 1, false);
            });
        }
    }
    
    ////////////////////////////////////////////////////////////////////////////
    // SITE TOUR CAROUSEL SUPPORT
    ////////////////////////////////////////////////////////////////////////////
    function ModalSiteTourCarousel(count, current) {
        var TargetCurrent = $(".modal-body-carousel-status-current");
        var TargetCount = $(".modal-body-carousel-status-count");

        TargetCurrent.text(current + 1);
        TargetCount.text(count);
    }

    ////////////////////////////////////////////////////////////////////////////
    // SITE TOUR SCROLL SUPPORT
    ////////////////////////////////////////////////////////////////////////////
    function ModalSiteTourScroll() {
        $("#ModalSiteTour").on("scroll", function () {
            if ($(this).scrollTop() > 0) {
                $(this).find(".modal-close").css({ top: 10 + $(this).scrollTop() });
            }
            else {
                $(this).find(".modal-close").removeAttr("style");
            }
        });
    }

    function init() {
        ModalsTriggers();
        ModalSiteTour();
        ModalSiteTourSlides();
        ModalSiteTourScroll();
        if ($(window).width() >= 991) {
            $(".site-tour-intro .layout").css("height", 600 + "px");
            $(".site-tour-item .layout").css("height", 600 + "px");
        }
    }


    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SiteModals.init();
});